import CommercialCalculator from "components/Calculators/CommercialCalculator";

const Home = () => {
  return <CommercialCalculator />;
};

export default Home;
